<template>
  <div>
    <div>
    <div class="header">
      <div :class="isFixed?'fixed':''">
      <div class="logo">
        <a href="javascript:;" @click="$goToHome()">
          <img :src="logoSrc" @click="$goToHome()" v-if="logoSrc&&false">
        <figure class="logo-icon" :style="{'backgroundImage':'url('+ logoSrc +')'}" v-if="logoSrc"></figure>
        </a>
      </div>
      </div>
    </div>
    <slot></slot>
    <div class="footer" ref="footer">

<div :class="isFooterFixed?'fixed':''">

      <div class="menu">
        <a href="javascript:;" class="icon btn-mask" @click="cliclMenu()">
            <figure :class="'menu-icon'+iconClassValue" :style="{'backgroundImage':'url('+ navSrc +')'}" v-if="navSrc"></figure>
          <img :src="navSrc" v-if="false">
        </a>
        <transition name="slide-left">
          <div class="menu-list" :class="colorName" v-show="show">
            <ul>
              <li @click="$goToMenu(1)">
                <span v-if="this.$store.state.language.name==='cn'" :class="'title-'+getLanguageName">作品</span>
                <span v-if="this.$store.state.language.name==='en'" :class="'title-'+getLanguageName">Work</span>
<!-- 
                 <figure :class="'projects-icon-'+getLanguageName" :style="{'backgroundImage':'url('+ projectsSrc +')'}" v-else-if="projectsSrc && this.$store.state.language.name=='en' && false"></figure> 

                <img :src="projectsSrc" v-if="false"> -->
              </li>

              <li @click="$goToMenu(3)">
                   <span v-if="this.$store.state.language.name==='cn'" :class="'title-'+getLanguageName">刊物</span>
                <span v-if="this.$store.state.language.name==='en'" :class="'title-'+getLanguageName">Publications</span>

<!--                 <figure :class="'publication-icon-'+getLanguageName" :style="{'backgroundImage':'url('+ publicationSrc +')'}" v-else-if="publicationSrc && this.$store.state.language.name=='en'&&false"></figure> 
                <img :src="publicationSrc"  v-if="false">
               -->
               </li>
              <li @click="$goToMenu(2)">
                   <span v-if="this.$store.state.language.name==='cn'" :class="'title-'+getLanguageName">学术</span>
                <span v-if="this.$store.state.language.name==='en'" :class="'title-'+getLanguageName">Academic</span>  
                            
<!--                   <figure :class="'exhibition-icon-'+getLanguageName" :style="{'backgroundImage':'url('+ exhibitionSrc +')'}" v-else-if="exhibitionSrc && this.$store.state.language.name=='en'&&false"></figure> 
                <img :src="exhibitionSrc"  v-if="false">-->
                </li> 

              <li @click="$goToMenu(12)">
                   <span v-if="this.$store.state.language.name==='cn'" :class="'title-'+getLanguageName">奖项</span>
                <span v-if="this.$store.state.language.name==='en'" :class="'title-'+getLanguageName">Awards</span>  
                            
<!--                   <figure :class="'exhibition-icon-'+getLanguageName" :style="{'backgroundImage':'url('+ exhibitionSrc +')'}" v-else-if="exhibitionSrc && this.$store.state.language.name=='en'&&false"></figure> 
                <img :src="exhibitionSrc"  v-if="false">-->
                </li>                 
                
              <li @click="$goToAbout()">
                <span v-if="this.$store.state.language.name==='cn'" :class="'title-'+getLanguageName">关于</span>
                <span v-if="this.$store.state.language.name==='en'" :class="'title-'+getLanguageName">About</span>               
<!-- 
                <figure :class="'office-icon-'+getLanguageName" :style="{'backgroundImage':'url('+ officeSrc +')'}" v-else-if="officeSrc && this.$store.state.language.name=='en'&&false"></figure> 
                <img :src="officeSrc" v-if="false"> -->
                </li>
            </ul>
          </div>
        </transition>
      </div>


      <div class="search-lang">
        <a @click="$goToSearch()" class="search btn-mask">
           <figure :class="getLanguageName=='cn'?'search-icon-cn':'search-icon-en'" :style="{'backgroundImage':'url('+ searchSrc +')'}" v-if="searchSrc"></figure> 
          <img :src="searchSrc" v-if="false">
        </a>
        <a @click="changeLanguage()" class="lang btn-mask">
            <figure :class="getLanguageName=='cn'?'lang-icon-en':'lang-icon-cn'" :style="{'backgroundImage':'url('+ langSrc +')'}" v-if="langSrc"></figure> 
          <img :src="langSrc" v-if="false"></a>
      </div>

      </div>


    </div>
    <div class="mask"></div>
    </div>

    <div class="dj-admin-loading" v-show="isLoadingShow" v-if="false"></div>
  </div>


     
</template>

<script>
export default {
  name: "Container",
  data() {
    return {

      logoEnPathB:'/static/img/logo-en-b.svg',
      logoEnPathW:'/static/img/logo-en-w.svg',

      logoCnPathB:'/static/img/logo-en-b.svg',
      logoCnPathW:'/static/img/logo-en-w.svg',      

/*       logoCnPathB:'/static/img/logo-cn-b.svg',
      logoCnPathW:'/static/img/logo-cn-w.svg', */
    
      // navPathB:'/static/img/nav-b.svg',
      // navPathW:'/static/img/nav-w.svg',
      
      navPathB:'/static/img/icon_plus.png',
      navPathW:'/static/img/icon_plus.png',


      searchPathB:'/static/img/search-b.svg',
      searchPathW:'/static/img/search-w.svg',

      langCnPathB:'/static/img/lang-cn-b.svg',
      langCnPathW:'/static/img/lang-cn-w.svg',
      langEnPathB:'/static/img/lang-en-b.svg',
      langEnPathW:'/static/img/lang-en-w.svg',


      exhibitionCnPathB:'/static/img/exhibition-cn-b.svg',
      exhibitionCnPathW:'/static/img/exhibition-cn-w.svg',
      exhibitionEnPathB:'/static/img/exhibition-en-b.svg',
      exhibitionEnPathW:'/static/img/exhibition-en-w.svg',


      officeCnPathB:'/static/img/office-cn-b.svg',
      officeCnPathW:'/static/img/office-cn-w.svg',
      officeEnPathB:'/static/img/office-en-b.svg',
      officeEnPathW:'/static/img/office-en-w.svg',

      projectsCnPathB:'/static/img/projects-cn-b.svg',
      projectsCnPathW:'/static/img/projects-cn-w.svg',
      projectsEnPathB:'/static/img/projects-en-b.svg',
      projectsEnPathW:'/static/img/projects-en-w.svg',

      publicationCnPathB:'/static/img/publication-cn-b.svg',
      publicationCnPathW:'/static/img/publication-cn-w.svg',
      publicationEnPathB:'/static/img/publication-en-b.svg',
      publicationEnPathW:'/static/img/publication-en-w.svg',


      exhibitionSrc:'',
      officeSrc:'',
      projectsSrc:'',
      publicationSrc:'',


      show: false,
      logoSrc: '',

      navSrc:'',
      searchSrc:'',
      langSrc:'',

      scrollHeight:0,

      colorID:1,

    

      imgCount:0,
      loadImgCount:0,

      colorName:'color-b',

      isFooterFixed:false,

      iconClassValue:'2',


   

    }
  },
  props: {

    logoHeightSet:{
        type: Array,
        default: () => []
    }, 

    isLoadingShow:{
      type: Boolean,
      default: true
    },
    isHeightSet:{
      type: Boolean,
      default: false
    },

    isFixed:{
      type: Boolean,
      default: true
    },    
    

  },
  components: {},

  methods: {

    changeData(){
      this.setColor(this.scrollHeight);
    },

    scroll() {

 

      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

      this.setColor(scrollTop)

      this.$emit('scroll', scrollTop)

      this.scrollHeight = scrollTop

     
    },


    setColor(scrollTop){

      if(this.logoHeightSet && this.logoHeightSet.length>0){

       
        let info = this.logoHeightSet.find(item => item.minHeight <= scrollTop && item.maxHeight>scrollTop);

        if(info){

          //  console.log(info.ColorID)

            this.colorID = info.ColorID

            if(this.colorID==1){
              this.colorName = 'color-b'
            }else{
              this.colorName = 'color-w'
            }

            this.changeLogoSrc(info.ColorID)//默认黑色
            this.changeFooterSrc(info.ColorID)
        }       

      }else{
        if(!this.isHeightSet){

          this.changeLogoSrc(1)//默认黑色
          this.changeFooterSrc(1)//默认黑色
        }

      } 
 
 
    },

    changeLogoSrc(colorID){

          if(colorID==1){

              if(this.$store.state.language.name==='cn'){
                this.logoSrc = this.logoCnPathB
              }else{
                this.logoSrc = this.logoEnPathB
              }


          }else{
         
              if(this.$store.state.language.name==='cn'){
                this.logoSrc = this.logoCnPathW
              }else{
                this.logoSrc = this.logoEnPathW
              }

            }

    /*   if(colorID==1){
        this.logoSrc =  this.logoPathB
      }else{
        this.logoSrc =  this.logoPathW
      } */
    },

    changeFooterSrc(colorID){

      this.changeNavSrc(colorID)

      this.changeSearchSrc(colorID)

      this.changeLanguageSrc(colorID)
    },

    changeSearchSrc(colorID){

          if(colorID==1){
          
            this.searchSrc = this.searchPathB
          }else{


            this.searchSrc = this.searchPathW

           
          }
    },

    changeLanguageSrc(colorID){

          if(colorID==1){

              if(this.$store.state.language.name==='cn'){
                this.langSrc = this.langEnPathB
              }else{
                this.langSrc = this.langCnPathB
              }


          }else{
         
              if(this.$store.state.language.name==='cn'){
                this.langSrc = this.langEnPathW
              }else{
                this.langSrc = this.langCnPathW
              }

            }
    },



    changeNavSrc(colorID){

      if(colorID==1){

        this.navSrc = this.navPathB

        if(this.$store.state.language.name==='cn'){

          this.projectsSrc = this.projectsCnPathB
          this.officeSrc = this.officeCnPathB
          this.exhibitionSrc = this.exhibitionCnPathB
          this.publicationSrc =  this.publicationCnPathB

        }else{

          this.projectsSrc = this.projectsEnPathB
          this.officeSrc = this.officeEnPathB
          this.exhibitionSrc = this.exhibitionEnPathB
          this.publicationSrc =  this.publicationEnPathB

        }
      }else{

        this.navSrc = this.navPathW

        if(this.$store.state.language.name==='cn'){
          this.projectsSrc = this.projectsCnPathW
          this.officeSrc = this.officeCnPathW
          this.exhibitionSrc = this.exhibitionCnPathW
          this.publicationSrc =  this.publicationCnPathW         
        }else{


          this.projectsSrc = this.projectsEnPathW
          this.officeSrc = this.officeEnPathW
          this.exhibitionSrc = this.exhibitionEnPathW
          this.publicationSrc =  this.publicationEnPathW
        }
      }
    },

    btnMask() {
      const $ = jQuery
      $('.btn-mask').hover(function () {
        $(this).parent().css({zIndex: 100})
        $('.mask').fadeIn()
      }, function () {
        //$(this).parent().css({zIndex: ''})
        $('.mask').fadeOut()
      })
    },

    cliclMenu(){
        this.show=!this.show
         const $ = jQuery
         if(this.show){
           this.iconClassValue = '';
           $(".menu").css('left','-18px');
           this.navSrc = '/static/img/nav-b.svg';
           this.isFooterFixed= true
         }else{
            this.iconClassValue = '2';
           this.navSrc = '/static/img/icon_plus.png';
           $(".menu").css('left','12px');
    
           this.isFooterFixed= false
         }
    },

    changeLanguage(){

        // console.log(this.colorID)

      this.$store.dispatch('language/changeLanguage')

      if(this.colorID==1){

              if(this.$store.state.language.name==='cn'){
                this.langSrc = this.langEnPathB
              }else{
                this.langSrc = this.langCnPathB
              }
      }else{

              if(this.$store.state.language.name==='cn'){
                this.langSrc = this.langEnPathW
              }else{
                this.langSrc = this.langCnPathW
              }
      }

    },



  },
  computed: {

    getLanguageName(){
      return this.$store.state.language.name
    },

  },

  mounted() {


 
    this.$nextTick(() => {
      window.addEventListener("scroll", this.scroll, false)
    })

   
  },

  watch:{
     logoHeightSet:{
      immediate: true,
      handler() {

       //val console.log('handler'+JSON.stringify(val))

        this.scroll()
      }
    }, 
    getLanguageName(){
      this.changeData()
    }


  }
}
</script>

<style>
/* .dj-admin-loading{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}
.dj-admin-loading:before{
  content:"";
width:30px;height:30px;margin:0 auto;display:block;border-radius:50%;
background-color:#409eff;animation:loading-bounce .3s cubic-bezier(0.05,0,0.2,1) infinite alternate}
.dj-admin-loading:after{content:"";width:10px;height:2px;margin:0 auto;display:block;
border-radius:50%;background-color:#BBB;animation:loading-shadow .3s cubic-bezier(0.05,0,0.2,1) infinite alternate}
@keyframes loading-bounce{from{transform:translateY(0)}to{transform:translateY(-40px)}}
@keyframes loading-shadow{from{transform:scale(1,1);opacity:1}to{transform:scale(3,2);opacity:.3}} */ 
</style>
